import React, { useEffect, useState, useRef } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime, { set } from 'animejs';
import HomeButton from '../utils/HomeButton';
import { Navigate, useNavigate } from 'react-router-dom';


const audioVoyelleNormal = new Audio(process.env.PUBLIC_URL + "/assets/sounds/Voyellenormale.wav");
const audioVoyelleI = new Audio(process.env.PUBLIC_URL + "/assets/sounds/Voyelle-i-synchro.wav");


const SardaigneMesereB = (props) => {
        const navigate = useNavigate();
            
            

            const handleImageError = (e) => {
                console.error("Error loading image:", e);
                console.log("Attempted path:", process.env.PUBLIC_URL + "/assets/images/sardaigne/mesere/mesere_B/depart_mesere_b.png");
            };
        
            const [showBoardImage, setShowBoardImage] = useState(false);
            const [isPlaying, setIsPlaying] = useState(false);
            const [showSuivantImage, setShowSuivantImage] = useState(false);
            const [showExplicationI, setShowExplicationI] = useState(false);
            const [isHoveredHarmonique, setIsHoveredHarmonique] = useState(false);
            const [audioProgress, setAudioProgress] = useState(0);
            const [pendingTime, setPendingTime] = useState(null);
            
        
            // choosing the audio file
            const [audio, setAudio] = useState(audioVoyelleNormal);
            useEffect(() => {
                    if (isPlaying) {
                        audio.play();
                    }
                }, [audio, isPlaying]);
            useEffect(() => {
                if (showExplicationI) {
                    setAudio(audioVoyelleI);
                } else {
                    setAudio(audioVoyelleNormal);
                }
            }, [showExplicationI]);
            
            useEffect(() => {
            if (pendingTime !== null && audio) {
                audio.currentTime = pendingTime;
                setPendingTime(null);
            }
        }, [audio, pendingTime]);

            useEffect(() => {
            let interval;
            if (isPlaying) {
                interval = setInterval(() => {
                    // Use audio.currentTime and audio.duration
                    if (audio.duration > 0) {
                        setAudioProgress(audio.currentTime / audio.duration);
                    }
                }, 50); // update every 50ms
            } else {
                setAudioProgress(0);
            }
            return () => clearInterval(interval);
            }, [isPlaying, audio]);
       
        
            
        
            // Add a state to track hover
            const [isHovered, setIsHovered] = useState(false);

            return (
                <div
                    style={{
                        backgroundColor: '#606494',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '660px',
                        height: '500px',
                    }}
                >
                    {/* Display image en arrivant sur la page mesere */}
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/depart_mesere_b.png`}
                        onError={handleImageError}
                        alt={`Sardaigne Mesere Voyelles`}
                        style={{
                            position: 'absolute',
                            top: '25px',
                            left: '0px',
                            zIndex: 1,
                            width: '660px',
                        }}
                    />

                    <div
                        style={{
                            height: '2px',
                            backgroundColor: 'grey',
                            marginTop: '5px',
                        }}
                    ></div>

                    {/* Play and Pause Buttons */}
                    <button
                        style={{
                            position: 'absolute',
                            top: '441px',
                            left: '123px',
                            zIndex: 6,
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            if (!isPlaying) {
                                audio.play();
                                setIsPlaying(true);
                            }
                            else {
                                audio.pause();
                                setIsPlaying(false);
                            }
                        }}
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/play.png`}
                            alt="Play Button"
                            style={{ width: '35px', height: '36px' }}
                        />
                    </button>
                    <button
                        style={{
                            position: 'absolute',
                            top: '440px',
                            left: '145px',
                            zIndex: 6,
                            backgroundColor: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            if (isPlaying) {
                                audio.pause();
                                setIsPlaying(false);
                                audio.currentTime = 0;
                            }
                        }}
                    >
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/pause.png`}
                            alt="Pause Button"
                            style={{ width: '38px', height: '37px' }}
                        
                        />
                    </button>

                    {showSuivantImage && (
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/ecran_suivant.png`}
                            onError={handleImageError}
                            alt={`Sardaigne Mesere Ecran Suivant`}
                            style={{
                                position: 'absolute',
                                top: '28px',
                                left: '0px',
                                zIndex: 4,
                                width: '660px',
                            }}
                        />
                    )}
                    {!showSuivantImage && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '230px',
                                left: '380px',
                                zIndex: 5,
                                width: '170px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={() => {setShowSuivantImage(true);
                                audio.pause();
                                audio.currentTime = 0;
                                setAudio(audioVoyelleNormal);
                                setIsPlaying(false);
                            }}
                        ></button>
                    )}
                    {/* Aller a l'écran Consonnes */}
            {(<div
                    style={{
                        position: 'absolute',
                        top: '455px',
                        left: '470px',
                        zIndex: 3,
                    }}
                >
                    <button
                        style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            color: 'grey',
                            fontSize: '15px',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = 'white';
                            e.target.nextSibling.style.backgroundColor = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = 'grey';
                            e.target.nextSibling.style.backgroundColor = 'grey';
                        }}
                        onClick={() => 
                            {window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/'+'sardaigne/consonnes/'
                            //navigate(process.env.PUBLIC_URL + '/sardaigne/consonnes/');
                            }
                        }
                    >
                        &gt; Consonnes
                    </button>
                    <div
                        style={{
                            height: '2px',
                            backgroundColor: 'grey',
                            marginTop: '5px',
                        }}
                    ></div>
                </div>
            )}


                    {/*Boutton pour passer sur i*/ }
                    {showSuivantImage && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '450px',
                                left: '350px',
                                zIndex: 5,
                                width: '120px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={() => {
                                audio.pause();
                            
                                setIsPlaying(false);
                                setPendingTime(audio.currentTime);
                                setAudio(audioVoyelleI);
                                setShowSuivantImage(false);
                                setShowExplicationI(true);
                                
                                setIsPlaying(true); // This will trigger the useEffect above
                                
                            }}
                        ></button>
                    )}
                    {/* Affichage de l'explication i */ }
                    {showExplicationI && !(showSuivantImage) &&(
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/voyelle_e.png`}
                            onError={handleImageError}
                            alt={`Sardaigne Mesere Ecran Voyelle e`}
                            style={{
                                position: 'absolute',
                                top: '29px',
                                left: '0px',
                                zIndex: 4,
                                width: '660px',
                            }}
                        />
                    )}
                    {/*Boutton pour repasser sur e*/ }
                    {showExplicationI && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '450px',
                                left: '200px',
                                zIndex: 5,
                                width: '120px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={() => {
                                audio.pause();
                                setIsPlaying(false);
                                setPendingTime(audio.currentTime);
                                setAudio(audioVoyelleNormal);
                                setShowSuivantImage(true);
                                setShowExplicationI(false);
                                
                                setIsPlaying(true); // This will trigger the useEffect above
                                
                            }}
                        ></button>
                    )}
                    {/*Boutton fermer*/ }
                    {(showExplicationI || showSuivantImage) && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '140px',
                                left: '20px',
                                zIndex: 5,
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={() => {
                                setShowSuivantImage(false);
                                setShowExplicationI(false);
                                audio.pause();
                                audio.currentTime = 0;
                                setAudio(audioVoyelleNormal);
                                //audio = audioVoyelleNormal;
                                setIsPlaying(false);
                            }}
                        ></button>
                    )}
                    {/*Boutton Harmonique 2 et 3*/ }
                    {!showExplicationI && !showSuivantImage && (
                        <button
                            style={{
                                position: 'absolute',
                                top: '100px',
                                left: '190px',
                                zIndex: 5,
                                width: '120px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'none',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={() => setIsHoveredHarmonique(true)}
                            onMouseLeave={() => setIsHoveredHarmonique(false)}
                            
                        ></button>
                    )}
                    {/* Affichage de l'explication Harmonique 2 et 3 */ }
                    {isHoveredHarmonique && !(showSuivantImage) && !(showExplicationI) &&(
                        <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/hovered_harmoniques_2.png`}
                            onError={handleImageError}
                            alt={`Sardaigne Mesere Ecran Suivant`}
                            style={{
                                position: 'absolute',
                                top: '260px',
                                left: '52px',
                                zIndex: 4,
                                width: '588px',
                                height: '195px',
                            }}
                        />
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/harmonique_2.png`}
                            onError={handleImageError}
                            alt={`Harmonique 2 et 3`}
                            style={{
                                position: 'absolute',
                                top: '100px',
                                left: '195px',
                                zIndex: 4,
                                width: '120px',
                            }}
                        />
                        </div>
                    )}
                    {/* Affichage bouton suivant*/ }
                    {isHovered && !(showSuivantImage) && !(showExplicationI) &&(
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/mesere_B/bouton_suivant.png`}
                            onError={handleImageError}
                            alt={`Sardaigne Mesere Ecran Suivant`}
                            style={{
                                position: 'absolute',
                                top: '230px',
                                left: '380px',
                                zIndex: 4,
                                width: '170px',
                            }}
                        />
                    )}
                    {/* Affichage barre normal */ }
                    {isPlaying && !(showSuivantImage) && !(showExplicationI) &&(   
                    <div
                        style={{
                            position: 'absolute',
                            top: 263,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 180,
                            backgroundColor: 'black',
                            zIndex: 2,
                        }}
                    />
                    )}
                    {/* Affichage barre suivant */ }
                    {isPlaying && (showSuivantImage) && !(showExplicationI) &&(   
                    <div>
                    <div
                        style={{
                            position: 'absolute',
                            top: 68,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 175,
                            backgroundColor: 'black',
                            zIndex: 10,
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: 265,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 173,
                            backgroundColor: 'black',
                            zIndex: 10,
                        }}
                    />
                    </div>
                    )}
                    {/* Affichage barre normal */ }
                    {isPlaying && !(showSuivantImage) && !(showExplicationI) &&(   
                    <div
                        style={{
                            position: 'absolute',
                            top: 263,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 180,
                            backgroundColor: 'black',
                            zIndex: 2,
                        }}
                    />
                    )}
                    {/* Affichage barre I */ }
                    {isPlaying && !(showSuivantImage) && (showExplicationI) &&(   
                    <div>
                    <div
                        style={{
                            position: 'absolute',
                            top: 68,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 175,
                            backgroundColor: 'black',
                            zIndex: 10,
                        }}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            top: 265,
                            left: `${80+audioProgress * 552}px`, // 660 is the image width
                            width: '2px',
                            height: 173,
                            backgroundColor: 'black',
                            zIndex: 10,
                        }}
                    />
                    </div>
                    )}
                    </div>
            );
} 
export default SardaigneMesereB;